<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-kanban w-6 h-6 group-hover:text-[#2AABEE] transition-colors text-gray-400"
    aria-hidden="true"
  >
    <path d="M5 3v14" />
    <path d="M12 3v8" />
    <path d="M19 3v18" />
  </svg>
</template>

<script setup>
// Kanban icon component
</script>

<style scoped>
.lucide-kanban {
  display: inline-block;
  vertical-align: middle;
  width: 1.5rem; /* w-6 */
  height: 1.5rem; /* h-6 */
  color: #9ca3af; /* text-gray-400 */
  transition: color 0.15s ease-in-out; /* transition-colors */
}

.group:hover .lucide-kanban {
  color: #2aabee; /* group-hover:text-[#2AABEE] */
}
</style>
